module.exports = "/_next/static/images/TeamPlan-xs-dd4e87f8b12cce7d8e4ffed1b186ad8d.webp";